export default "__VITE_ASSET__DQCjYibi__"